/* eslint-disable arrow-parens */
// actions
import { setVehicle } from '../../Vehicle/actions';
// eslint-disable-next-line import/no-cycle
import { restorePlaces, toggleEditPlaces } from '../../Places/actions';
import {
  fetchDirectionsSuccess,
  toggleDirectionsUI,
} from '../../Directions/actions';
import { updateSuperchargersRoutechargers } from '../../Superchargers/actions';
// eslint-disable-next-line import/no-cycle
import { captureAppState } from '../../App/actions';

// helpers
import { makeActionCreator, saveTrip } from '../../../lib/Utils';
import MapUtils from '../../../lib/MapUtils';
import MapMarkers from '../../../lib/MapMarkers';

export const CANCELBTN_UPDATE_LABEL = 'CANCELBTN_UPDATE_LABEL';
export const updateCancelBtnLabel = makeActionCreator(
  CANCELBTN_UPDATE_LABEL,
  'label',
);

export function cancelEditing(prevState) {
  return dispatch => {
    const {
      Directions: { directions },
      Places,
      Superchargers: { superchargers },
      Vehicle,
    } = prevState;
    dispatch(setVehicle(Vehicle));

    dispatch(restorePlaces(Places));

    dispatch(fetchDirectionsSuccess(directions));

    dispatch(toggleEditPlaces(false));

    dispatch(toggleDirectionsUI(true, true));

    dispatch(captureAppState({}));

    MapUtils.setPolyline(prevState.Directions.polyline);
    MapUtils.fitMapToPolyline();

    MapMarkers.deleteMapMarkers(superchargers);

    const routeChargers = prevState.Superchargers.routechargers;
    MapMarkers.updateRoutechargerMarkers(routeChargers);
    dispatch(updateSuperchargersRoutechargers(routeChargers));

    // save the trip in encoded string so user can share/return to their trip
    saveTrip({ vehicle: Vehicle, places: prevState.Places });
  };
}
